<!-- 材料题 -->
<template>
    <div class="materials answerarea-item fontsize-16" :id="questionitem.innerid">
        <div class="topic-types">
            <p class="name"><span>{{questionitem.questionindex}}.</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
            <p class="title" v-html="questionitem.subject"></p>
            <div class="questionList">
                <div class="item" v-for="(item, index) in questionitem.questioninfo" :key="index">
                    <!-- 1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题 -->
                    <Radio v-if="item.questiontype == 1" :isMaterialsItem="true" :questioninfo="questionitem"  :questionitem="item" :examstatus="examstatus" :isshow="isshow"></Radio>
                    <!-- end 单选题 -->

                    <Checkbox v-else-if="item.questiontype == 2 || item.questiontype == 3" :questioninfo="questionitem" :isMaterialsItem="true" :questionitem="item" :examstatus="examstatus" :isshow="isshow"></Checkbox>
                    <!-- end 多选题、不定项选择题 -->

                    <Judge v-else-if="item.questiontype == 4" :questionitem="item" :questioninfo="questionitem" :isMaterialsItem="true" :examstatus="examstatus" :isshow="isshow"></Judge>
                    <!-- end 判断题 -->

                    <QuestionsAndAnswers v-else-if="item.questiontype == 5" :questionitem="item" :isMaterialsItem="true" :questioninfo="questionitem" :examstatus="examstatus" :isshow="isshow"></QuestionsAndAnswers>
                    <!-- end 填空题 -->

                    <FillInTheBlanks v-else-if="item.questiontype == 6" :questionitem="item" :isMaterialsItem="true" :questioninfo="questionitem" :examstatus="examstatus" :isshow="isshow" :ischeckover="ischeckover"></FillInTheBlanks>
                    <!-- end 问答题 -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from './Checkbox'
import FillInTheBlanks from './FillInTheBlanks'
import Judge from './Judge'
import QuestionsAndAnswers from './QuestionsAndAnswers'
import Radio from './Radio'
export default {
    props: ['questionitem', 'examstatus', 'isshow', 'ischeckover'],  // 试题列表 试卷提交状态 是否显示正确答案
    data() {
        return {

        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {

    },
    components: {
        Checkbox,
        FillInTheBlanks,
        Judge,
        QuestionsAndAnswers,
        Radio
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .materials {
        .questionList {
            // padding-left: ;
        }
    }
</style>